import { Modal } from '@/components/common/dialog';
import { ModalButton } from '@/components/common/modal-button';
import { useTranslation } from 'react-i18next';

interface SpeakerCloseModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export function SpeakerCloseModal({ isOpen, onClose, onConfirm }: SpeakerCloseModalProps) {
    const { t } = useTranslation();

    return (
        <Modal isOpen={isOpen} onClose={onClose} className="max-w-[calc(680*var(--vw-unit))] tts-modal" closeRegionOrder={4}>
            <div className="flex h-full flex-col">
                <header className="text-text-main01 px-[calc(56*var(--vh-unit))] pt-[calc(56*var(--vh-unit))] pb-[calc(8*var(--vh-unit))] text-[calc(32*var(--vh-unit))] leading-normal font-bold tracking-[calc(-1.276*var(--vh-unit))]">
                    <h1 data-modal-region tabIndex={0} data-interactive aria-label={t('speakerClose.title')} className="text-center font-bold focus-border ">
                        {t('speakerClose.title')}
                    </h1>
                </header>
                <main className="px-[calc(112*var(--vw-unit))]">
                    <div className="mt-[calc(24*var(--vh-unit))] mb-[calc(40*var(--vh-unit))]">
                        <p
                            tabIndex={0}
                            data-interactive
                            aria-label={t('speakerClose.description')}
                            className="text-text-main01 text-center text-[calc(24*var(--vh-unit))] leading-[calc(30*var(--vh-unit))] font-medium tracking-[calc(-0.108*var(--vh-unit))] focus-border "
                            dangerouslySetInnerHTML={{ __html: t('speakerClose.description') }}  data-modal-region data-modal-region-order={1}
                        ></p>
                    </div>
                </main>
                <footer className="flex justify-center gap-[calc(23*var(--vw-unit))] px-[calc(56*var(--vh-unit))] pt-[calc(24*var(--vh-unit))] pb-[calc(52*var(--vh-unit))]">
                    <ModalButton role="button" variant="secondary" aria-label={t('speakerClose.buttons.close')} onClick={onClose} data-interactive type="button" data-modal-region data-modal-region-order={2}>
                        {t('speakerClose.buttons.close')}
                    </ModalButton>
                    <ModalButton role="button" variant="primary" aria-label={t('speakerClose.buttons.confirm')} onClick={onConfirm} data-interactive type="button" data-modal-region data-modal-region-order={3}>
                        {t('speakerClose.buttons.confirm')}
                    </ModalButton>
                </footer>
            </div>
        </Modal>
    );
}
